import { COMMON_MIXPANEL_PAGE } from './mixpanelConstants'

export enum STICKY_QUERY_PARAMS {
  UTM_SOURCE = 'utm_source',
  UTM_MEDIUM = 'utm_medium',
  UTM_CAMPAIGN = 'utm_campaign',
}

export enum UTM_CAMPAIGN {
  ELECTION = 'election2024',
  REFERRAL = 'referral',
  SAVED_PROVIDER_RESULTS_REENGAGEMENT = 'replay-providers-reengagement',
  FAVORITED_PROVIDERS_REMINDER = 'favorited-providers-reminder',
  GOOGLE_CRITICAL_TALENT = 'google-critical-talent',
  PARENTAL_LEAVE_COACHING = 'parental leave coaching',
  MANAGER_COACHING = 'manager coaching',
}

export enum UTM_MEDIUM {
  PRODUCT = 'product',
  ORGANIC = 'organic',
  PRODUCT_MOBILE = 'product-mobile',
  PRODUCT_DESKTOP = 'product-desktop',
  EMAIL_MOBILE = 'email-mobile',
  EMAIL_DESKTOP = 'email-desktop',
  PUSH = 'push',
}

export enum UTM_SOURCE {
  HOMEBASE = COMMON_MIXPANEL_PAGE.HOME_BASE,
  LOGIN_PAGE = 'login-page',
  HAMBURGER_MENU = 'hamburger-menu',
  PATHWAYS_MICROSITE_BANNER = 'pathways-microsite-banner',
  COMING_SOON_MICROSITE_BANNER = 'coming-soon-microsite-banner',
  WELCOME_EMAIL = 'welcome-email',
}

export const parentalLeaveUtmCampaignString = 'parental leave'

export const managerCoachingUtmCampaignString = 'manager coaching'
